import React from "react";

// Subtle Dominican-themed seamless pattern: stylized palm fronds + flag colors
// Use as a CSS background-image via the exported `dataUrl` or as JSX <DominicanPattern />
export const DominicanPattern = ({ className = "", opacity = 0.06 }) => (
    <svg
        className={className}
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
    >
        <defs>
            <pattern id="dom-pattern" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
                {/* palm frond */}
                <g opacity={opacity * 10} transform="translate(40 40) rotate(45)">
                    <path
                        d="M0 -20 Q -4 -10 0 0 Q 4 -10 0 -20 M0 -10 Q -8 -2 0 4 Q 8 -2 0 -10 M0 0 Q -10 8 0 14 Q 10 8 0 0"
                        fill="none"
                        stroke="#4A7C59"
                        strokeWidth="0.8"
                        strokeLinecap="round"
                    />
                </g>
                {/* small flag dot */}
                <circle cx="10" cy="10" r="1.4" fill="#CE1126" opacity={opacity * 6} />
                <circle cx="70" cy="70" r="1.4" fill="#002D62" opacity={opacity * 6} />
                <circle cx="70" cy="20" r="1" fill="#C85A17" opacity={opacity * 8} />
                <circle cx="20" cy="70" r="1" fill="#C85A17" opacity={opacity * 8} />
            </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dom-pattern)" />
    </svg>
);

// Decorative palm leaf for hero / section corners
export const PalmLeaf = ({ className = "", color = "#4A7C59" }) => (
    <svg viewBox="0 0 120 200" className={className} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M60 200 Q 58 140 50 100 Q 30 70 10 50 Q 36 60 56 80 Q 46 50 36 28 Q 56 46 62 70 Q 70 40 78 18 Q 76 52 70 80 Q 92 56 110 38 Q 92 70 78 96 Q 92 86 110 90 Q 88 100 70 116 Q 84 116 100 122 Q 78 124 64 130 Q 64 168 60 200 Z"
            fill={color}
            opacity="0.85"
        />
    </svg>
);

// Outline of Dominican Republic island shape (rough but recognizable)
export const DominicanIsland = ({ className = "", color = "#C85A17" }) => (
    <svg viewBox="0 0 200 100" className={className} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 55 Q 18 38 36 36 Q 56 28 80 32 Q 100 28 124 30 Q 150 30 172 40 Q 190 50 186 62 Q 178 72 158 70 Q 134 76 110 72 Q 88 74 66 70 Q 44 70 28 66 Q 14 64 10 55 Z"
            fill={color}
            opacity="0.85"
        />
        {/* Marker for Santo Domingo */}
        <circle cx="100" cy="58" r="2.5" fill="#FFFFFF" />
        <circle cx="100" cy="58" r="1.2" fill="#CE1126" />
    </svg>
);
